import ActionTypes from '@ziynx/action-types';

type AdminActions = {
  type: string,
  id: string,
}

const initialState = {
  newNIL: {
    fetching: false,
    posting: false,
  },
};

export default function reduceNIL(state = initialState, action: AdminActions) {
  switch (action.type) {
  case ActionTypes.NIL.post.START:
    return {
      ...state,
      newNIL: {
        posting: true,
      },
    };
  case ActionTypes.NIL.post.SUCCESS:
    return {
      ...state,
      newNIL: {
        posting: false,
      },
    };
  case ActionTypes.NIL.post.ERROR:
    return {
      ...state,
      newNIL: {
        posting: false,
      },
    };
  case ActionTypes.NIL.get.START:
    return {
      ...state,
      newNIL: initialState.newNIL,
      [action.id]: {
        ...(state[action?.id] || {}),
        fetching: true,
      },
    };

  case ActionTypes.NIL.get.SUCCESS:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        fetching: false,
      },
    };

  case ActionTypes.NIL.get.ERROR:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        fetching: false,
      },
    };

  case ActionTypes.NIL.patch.START:
    return {
      ...state,
      [action.id]: {
        ...(state[action?.id] || {}),
        isPatching: true,
      },
    };

  case ActionTypes.NIL.patch.SUCCESS:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        isPatching: false,
      },
    };

  case ActionTypes.NIL.patch.ERROR:
    return {
      ...state,
      [action.id]: {
        ...(action?.response || {}),
        isPatching: false,
      },
    };

  case ActionTypes.NIL.clearUploads:
    return {
      ...state,
      [action.id]: {},
    };

  default:
    return state;
  }
}
